import React from 'react';
import glamorous, {withTheme, Div, H1, H3, P, A, Img} from 'glamorous';
import {TransitionMotion, spring} from 'react-motion';

import theme from './theme';
import close from './close.png';

const InputContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '15px'
});

const InputLabel = glamorous.label({
  margin: '0 0 5px 4px'
});

const Input = glamorous.input({
  padding: 10,
  borderRadius: 5,
  border: '2px solid #D9D9D9',
  outline: 0,
  color: theme.textColor,
  ':focus': {
    borderColor: '#C0DDE1'
  }
});

const Select = glamorous.select({
  padding: 15,
  borderRadius: 5,
  minHeight: 42,
  backgroundColor: 'transparent',
  outline: 0,
  border: '2px solid #D9D9D9',
  ':focus': {
    borderColor: '#C0DDE1'
  }
});

const Option = glamorous.option({
  padding: 20
});

class Modal extends React.PureComponent {
  makeInitialState = () => ({
    name: '',
    company: '',
    email: '',
    phoneNumber: '',
    teamSize: 'Small (1-100)',
    isLoading: false,
    error: undefined,
    success: undefined
  });

  state = this.makeInitialState();

  render() {
    const {isOpen} = this.props;
    const {
      name,
      company,
      email,
      phoneNumber,
      teamSize,
      isLoading,
      error,
      success
    } = this.state;
    return (
      <TransitionMotion
        willLeave={() => ({
          y: spring(-20, {stiffness: 150, damping: 13}),
          opacity: spring(0, {stiffness: 150, damping: 13})
        })}
        willEnter={() => ({y: -20, opacity: 0.5})}
        styles={
          isOpen
            ? [
                {
                  key: 'modal',
                  style: {
                    y: spring(0, {stiffness: 150, damping: 13}),
                    opacity: spring(1, {stiffness: 150, damping: 13})
                  }
                }
              ]
            : []
        }
      >
        {interpolatedStyles => {
          const config = interpolatedStyles[0];
          if (!config) {
            return null;
          }
          return (
            <div
              style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                backgroundColor: 'rgba(0,0,0,0.3)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                opacity: config.style.opacity,
                transform: 'translateZ(0)'
              }}
              onClick={this.handleClose}
            >
              <div
                style={{
                  position: 'relative',
                  width: '500px',
                  maxHeight: '100vh',
                  overflow: 'auto',
                  maxWidth: '95%',
                  backgroundColor: '#FFFFFF',
                  paddingTop: '15px',
                  boxShadow: '0 3px 30px rgba(0,0,0,0.3)',
                  color: theme.textColor,
                  borderRadius: 5,
                  transform: `translateY(${config.style.y}px)`
                }}
                onClick={event => event.stopPropagation()}
              >
                <Img
                  cursor="pointer"
                  width="12px"
                  position="absolute"
                  top="0"
                  right="0"
                  padding="25px"
                  src={close}
                  onClick={this.handleClose}
                />
                {success
                  ? <Div padding="50px">
                      Thank you. We will be in touch as soon as possible!
                    </Div>
                  : <Div>
                      <H3 textAlign="center">Create a Team</H3>
                      <Div padding="0 30px 30px 30px">
                        <InputContainer>
                          <InputLabel>Name</InputLabel>
                          <Input
                            type="text"
                            value={name}
                            onChange={event =>
                              this.setState({name: event.target.value})}
                          />
                        </InputContainer>
                        <InputContainer
                          display="flex"
                          flexDirection="column"
                          marginTop="20px"
                        >
                          <InputLabel>Email</InputLabel>
                          <Input
                            type="email"
                            value={email}
                            onChange={event =>
                              this.setState({email: event.target.value})}
                            required
                          />
                        </InputContainer>
                        <InputContainer
                          display="flex"
                          flexDirection="column"
                          marginTop="20px"
                        >
                          <InputLabel>Phone number</InputLabel>
                          <Input
                            type="tel"
                            value={phoneNumber}
                            onChange={event =>
                              this.setState({phoneNumber: event.target.value})}
                            required
                          />
                        </InputContainer>
                        <InputContainer
                          display="flex"
                          flexDirection="column"
                          marginTop="20px"
                        >
                          <InputLabel>Company</InputLabel>
                          <Input
                            type="text"
                            value={company}
                            onChange={event =>
                              this.setState({company: event.target.value})}
                          />
                        </InputContainer>
                        <InputContainer
                          display="flex"
                          flexDirection="column"
                          marginTop="20px"
                        >
                          <InputLabel>Team size</InputLabel>
                          <Select
                            value={teamSize}
                            onChange={event =>
                              this.setState({teamSize: event.target.value})}
                          >
                            <Option value="Small (1-100)">1-100</Option>
                            <Option value="Medium (100-500)">100-500</Option>
                            <Option value="Large (500-1000+)">500-1000</Option>
                            <Option value="HUGE (1000+)">1000+</Option>
                          </Select>
                        </InputContainer>
                      </Div>
                      {error && <Div padding="0 40px 20px 40px">{error}</Div>}
                      <A
                        display="block"
                        padding="20"
                        textAlign="center"
                        backgroundColor={theme.baseColor}
                        color="#FFFFFF"
                        font={theme.fontMedium}
                        href="#"
                        textDecoration="none"
                        transition="all 200ms"
                        outline="0"
                        borderRadius="0 0 5px 5px"
                        css={{
                          ':hover': {
                            backgroundColor: !isLoading && theme.baseColorDarker
                          },
                          ':focus': {
                            backgroundColor: theme.baseColorDarker
                          }
                        }}
                        onClick={!isLoading && this.handleSend}
                      >
                        {isLoading ? 'Sending...' : 'Send'}
                      </A>
                    </Div>}
                <Div />
              </div>
            </div>
          );
        }}
      </TransitionMotion>
    );
  }

  handleClose = () => {
    this.setState(this.makeInitialState());
    this.props.onCloseModal();
  };

  handleSend = () => {
    const {name, company, email, phoneNumber, teamSize} = this.state;

    if (!email || email.length <= 3 || email.indexOf('@') === -1) {
      return this.setState({
        error: 'Please make sure you entered your email address.'
      });
    }

    this.setState({isLoading: true, error: false, success: false});
    fetch(
      'https://us-central1-viska-mobile-app.cloudfunctions.net/createTeamRequest',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          company,
          email,
          phoneNumber,
          teamSize
        })
      }
    )
      .then(res => res.json())
      .then(res => {
        if (!res.ok) {
          return this.setState({
            isLoading: false,
            error:
              'Whoops! Something went wrong, please try again or contact us directly at hello@viska.com.'
          });
        }
        this.setState({
          isLoading: false,
          success: true
        });
      });
  };
}
export default withTheme(Modal);



// WEBPACK FOOTER //
// ./src/pages/Landing/Modal.js